import { render, staticRenderFns } from "./TopProdutosVendidos.vue?vue&type=template&id=bcf9d190"
import script from "./TopProdutosVendidos.vue?vue&type=script&lang=js"
export * from "./TopProdutosVendidos.vue?vue&type=script&lang=js"
import style0 from "./TopProdutosVendidos.vue?vue&type=style&index=0&id=bcf9d190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports